import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import userModule from './modules/user'
import rolesModule from './modules/roles'
import companyModule from './modules/company'

Vue.use(Vuex);

const store = new Vuex.Store({
    state:{
        open_menu: false,
        open_submenu: false,

        constants: {},

        left_open: true,
        menu_projects: {},

        current_project: {},
        current_iso: {},
        current_company: {},

        preloader: true,
        ajax_in_progress: false,

        site_name: "Pipe Digital",
        page_title: null,

        userCompanies: {},
        userSelectedRole: {},

        language: 'en',

        go_back_url: '',
        go_back_data: {},
        came_from_url: '',

        go_back_url_list: [''],
        go_back_data_list: [],
        go_back_index: 0,

        // minItemsForSelect: 10,
    },
    modules: {
        user: userModule,
        roles: rolesModule,
        company: companyModule,
    },
    getters,
    mutations,
    actions
})
//=======vuex store end===========
export default store



// WEBPACK FOOTER //
// ./src/store/index.js